import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

const MOBILEVIEWWIDTH = 575;
@Component({
  selector: 'app-panels',
  templateUrl: './panels.component.html',
  styleUrls: ['./panels.component.css']
})
export class PanelsComponent implements OnInit {

  private panelsContainer: HTMLElement;
  private prevViewWidth: number;
  isShowSidePanel: boolean = false;
  isShowBanners: boolean = true;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    if(this.platformId == '', this.panelsContainer == null) { this.panelsContainer = this.document.getElementById('comparatoreMFPanels'); }

    // Faccio la subscribe alla router per recuperare la url e verificare se siamo sulla pagina di dettaglio delle polizze e quindi non avremo la sidepanel
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(
      event => {
        const _url = this.router.url?.split("?")[0].toLocaleLowerCase();
        this.isShowSidePanel = !_url.startsWith('/policy') && !_url.startsWith('/glossario') && !_url.startsWith('/informative');
        this.isShowBanners = !_url.startsWith('/informative');
        
        if(this.panelsContainer != null) { this.setHeights(true); }
      }
    )
  }

  ngAfterContentChecked() {
    if(this.panelsContainer == null) { this.panelsContainer = this.document.getElementById('comparatoreMFPanels'); }
    if(this.panelsContainer != null && this.panelsContainer.offsetWidth != this.prevViewWidth) { this.setHeights(false); }
  }

  setHeights(scrollToTop: boolean = false) {
    const headerContainer = this.document.getElementById('comparatoreMFHeader');
    const footerContainer = this.document.getElementById('comparatoreMFFooter');
    if(this.panelsContainer.children != null && headerContainer != null && footerContainer != null) {
      const hHeader = headerContainer.offsetHeight;
      const hFooter = footerContainer.offsetHeight;
      const hHeaderFooter = hHeader + hFooter;

      let _panelsContentEl = this.panelsContainer.getElementsByClassName('panels-content')[0];
      if(_panelsContentEl != null) {
        (_panelsContentEl as HTMLElement).style.height = `calc(100vh - ${hHeaderFooter}px)`;

        if (scrollToTop) {
          _panelsContentEl.firstElementChild.scrollIntoView({ block: 'start' });
        }
      }

      let _rowEl = this.panelsContainer.getElementsByClassName('row')[0];
      if(_rowEl != null) {
        if(this.panelsContainer.offsetWidth > MOBILEVIEWWIDTH) {
          (_rowEl as HTMLElement).style.height = `calc(100vh - ${hHeaderFooter}px)`;
        }
        else {
          (_rowEl as HTMLElement).style.height = null;
        }
      }
      this.prevViewWidth = this.panelsContainer.offsetWidth;
    }
  }

}
